<template>
    <BannerClickWrapper
        :banner="banner"
        :current-category-id="currentCategoryId"
        :skip-product-modal="skipProductModal"
        :gtm-creative-slot="gtmCreativeSlot"
    >
        <img
            class="sm:hidden w-full h-auto block rounded-md"
            :src="mobileImageSrc"
            :alt="banner.label || ''"
            decoding="async"
            fetchpriority="high"
        >
        <img
            class="hidden sm:block w-full h-auto block rounded-md"
            :class="desktopImageClass"
            :src="desktopImageSrc"
            :srcset="desktopImageSrcset"
            :width="desktopIntrinsicWidth"
            :height="desktopIntrinsicHeight"
            :alt="banner.label || ''"
            decoding="async"
            fetchpriority="high"
        >
    </BannerClickWrapper>
</template>

<script>

import BannerClickWrapper from '../BannerClickWrapper.vue'

export default {
    name: 'BannerSingleImageTemplate',
    components: {
        BannerClickWrapper,
    },
    props: {
        banner: {
            required: true,
        },
        currentCategoryId: {
            type: Number,
            default: null,
        },
        skipProductModal: {
            type: Boolean,
            default: false,
        },
        /**
         * Display surface for GTM creative_slot (e.g. homepage_left, basket).
         */
        gtmCreativeSlot: {
            type: String,
            default: null,
        },
        /**
         * left = background (carousel), right = right_hand image, auto = prefer background then right.
         */
        imageSlot: {
            type: String,
            default: 'auto',
            validator: (imageSlot) => ['left', 'right', 'auto'].includes(imageSlot),
        },
        desktopImageClass: {
            type: String,
            default: 'max-w-[1280px] sm:mx-auto',
        },
    },
    computed: {
        usesRightHandImage() {
            if (this.imageSlot === 'right') {
                return true
            }
            if (this.imageSlot === 'left') {
                return false
            }

            return ! this.banner.background_image && Boolean(this.banner.right_hand_image)
        },
        desktopImageSrc() {
            if (this.usesRightHandImage) {
                return this.banner.right_hand_image || ''
            }

            return this.banner.background_image || this.banner.right_hand_image || ''
        },
        desktopImageSrc2x() {
            if (this.usesRightHandImage) {
                return this.banner.right_hand_image_2x || ''
            }

            return this.banner.background_image_2x || this.banner.right_hand_image_2x || ''
        },
        desktopImageSrcset() {
            if (! this.desktopImageSrc2x) {
                return undefined
            }

            return `${this.desktopImageSrc} 1x, ${this.desktopImageSrc2x} 2x`
        },
        mobileImageSrc() {
            return this.banner.mobile_image
                || this.desktopImageSrc
        },
        desktopIntrinsicWidth() {
            return this.usesRightHandImage ? 400 : 800
        },
        desktopIntrinsicHeight() {
            return 240
        },
    },
}

</script>
